import React, { useEffect, useState } from "react";
import { Box, Form, TextInput, FormField, Button } from "grommet";
import AuthService from "../../services/auth.service";
import { presentToastErrorContent, presentToastError } from "@shared/Toast";
import PasswordInput from "@shared/PasswordInput";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

// import PropTypes from 'prop-types';

export default function LoginComponent(props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const onUsernameChange = (event) => setUsername(event.target.value);
  const onPasswordChange = (event) => setPassword(event.target.value);
  const { t } = useTranslation();

  const { token, partner } = useParams();

  useEffect(() => {
    if (token) {
      AuthService.ssoLogin(partner, token).then(
        () => {
          window.location.href = "/";
        },
        (error) => {
          if (error.response && error.response.status === 404)
            presentToastError(t("login.userNotFound"));
          else presentToastErrorContent(error);
        },
      );
    }
  }, [partner, token, t]);

  const handleLogin = () => {
    AuthService.login(username?.trim(), password).then(
      () => {
        window.location.href = "/";
      },
      (error) => {
        if (error.response && error.response.status === 404)
          presentToastError(t("login.userNotFound"));
        else presentToastErrorContent(error);
      },
    );
  };

  return (
    <Form onSubmit={handleLogin}>
      <Box gap="medium">
        <FormField label={t("login.username")} htmlFor="username">
          <TextInput
            id="username"
            placeholder={t("login.usernamePlaceholder")}
            onChange={onUsernameChange}
          />
        </FormField>

        <FormField label={t("login.password")} htmlFor="password">
          <PasswordInput
            id="password"
            placeholder={t("login.passwordPlaceholder")}
            onChange={onPasswordChange}
          />
        </FormField>
        <Button
          label={t("login.loginButton")}
          primary
          type="submit"
          alignSelf="center"
        />
        <p align="center">
          <a href="/sign-in/forgot">{t("login.forgotPassword")}</a>
        </p>
      </Box>
    </Form>
  );
}

LoginComponent.propTypes = {};
LoginComponent.defaultProps = {};
